'use client';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Registro único — seguro llamarlo varias veces.
if (typeof window !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger);
}

export { gsap, ScrollTrigger };

/**
 * Animación de entrada escalonada para una lista de elementos.
 *
 * @param {string|NodeList} selector  Selector CSS o NodeList
 * @param {Element}         trigger   Contenedor para el ScrollTrigger
 * @param {object}          opts
 *   y        {number} — offset vertical inicial (default 24)
 *   stagger  {number} — retardo entre ítems (default 0.08)
 *   duration {number} — duración por ítem (default 0.5)
 */
export function staggerIn(selector, trigger, opts = {}) {
  const { y = 24, stagger = 0.08, duration = 0.5 } = opts;
  return gsap.from(selector, {
    y,
    opacity: 0,
    duration,
    stagger,
    ease: 'power2.out',
    scrollTrigger: { trigger, start: 'top 80%', once: true },
  });
}
